import React from "react";
import PropTypes from "prop-types";

import { Container, ContainerNoError } from "./styles";

export const AppErrorFormik = ({ error, visible }) => {
  if (!visible || !error) return <ContainerNoError />;
  return (
    <Container>
      <p>{error}</p>
    </Container>
  );
};

AppErrorFormik.propTypes = {
  error: PropTypes.string,
  visible: PropTypes.bool,
};
